var colors = {
    background: "#1C1A19",
    backgroundLighter: "#1F1D1C",
    backgroundDarker: "#08090E",
    border: "#2B2B2B",
    borderLight: "#2E2C2B",
    text: "#ACACAB",
    primaryText: "#FFFFFF",
    green: "#16CEB9",
    red: "#fc0a54",
    pillBackground: "#151413",
    tagBackground: "#1D222D",
    products: {
        yield: "#FF385C",
        volatility: "#FF9000",
        principalProtection: "#79FFCB",
        capitalAccumulation: "#729DED",
    },
    buttons: {
        primary: "#fc0a54",
        error: "rgba(252, 10, 84, 0.16)",
        secondaryBackground: "rgba(22, 206, 185, 0.08)",
        secondaryText: "#16ceb9",
    },
    vaultActivity: {
        sales: "#16ceb9",
        minting: "#729ded",
    },
    brands: {
        opyn: "#6FC0A2",
        hegic: "#45FFF4",
        charm: "#5A67D8",
        discord: "#5A65EA",
        primitive: "#FFFFFF",
    },
    asset: {
        WETH: "#627EEA",
        WBTC: "#E39652",
        USDC: "#3E73C4",
        yvUSDC: "#3E73C4",
    },
};
export default colors;
//# sourceMappingURL=colors.js.map